import Flickity from 'flickity';
import 'flickity/dist/flickity.css';

import ApplicationController from './application_controller';

export default class extends ApplicationController {
  connect() {
    this.initializeCarousel();
    this.element.addEventListener('htmx:afterSwap', this.handleAfterSwap.bind(this));
  }

  handleAfterSwap() {
    this.initializeCarousel();
  }

  initializeCarousel() {
    const carousels = this.element.matches('.carousel-explore')
      ? [this.element]
      : this.element.querySelectorAll('.carousel-explore');

    carousels.forEach((carousel) => {
      if (carousel.flickityInstance) {
        return;
      }

      carousel.querySelectorAll('img[src=""]').forEach((img) => {
        img.src = 'https://via.placeholder.com/1000x600.png?text=No+Picture';
      });

      const isPropertyGallery = carousel.id === 'limited-dots-carousel';

      const flickityOptions = {
        cellAlign: isPropertyGallery ? 'center' : 'left',
        contain: true,
        wrapAround: true,
        pageDots: true,
        prevNextButtons: !isPropertyGallery,
        draggable: true,
      };

      const flickityInstance = new Flickity(carousel, flickityOptions);
      carousel.flickityInstance = flickityInstance;

      imagesLoaded(carousel, () => {
        flickityInstance.resize();
      });

      flickityInstance.on('ready', () => {
        flickityInstance.resize();
      });

      setTimeout(() => {
        flickityInstance.resize();
      }, 150);

      if (isPropertyGallery) {
        this.setupSlidingDots(flickityInstance);
      }
    });
  }

  setupSlidingDots(flickityInstance) {
    const { dots } = flickityInstance.pageDots;
    const totalDots = dots.length;
    const maxVisible = 5;

    if (totalDots <= maxVisible) {
      return;
    }

    const updateDots = () => {
      const { selectedIndex } = flickityInstance;
      const halfVisible = Math.floor(maxVisible / 2); // 2

      let startIndex; let
        endIndex;

      if (selectedIndex <= halfVisible) {
        startIndex = 0;
        endIndex = maxVisible - 1;
      } else if (selectedIndex >= totalDots - 1 - halfVisible) {
        startIndex = totalDots - maxVisible;
        endIndex = totalDots - 1;
      } else {
        startIndex = selectedIndex - halfVisible;
        endIndex = selectedIndex + halfVisible;
      }

      dots.forEach((dot, i) => {
        if (i >= startIndex && i <= endIndex) {
          const distance = Math.abs(i - selectedIndex);
          const scale = Math.max(0, 1 - distance * 0.3);

          dot.style.display = 'block';
          dot.style.opacity = '1';
          dot.style.transform = `scale(${scale})`;
          dot.style.transition = 'transform 0.3s ease, opacity 0.3s ease';
        } else {
          dot.style.display = 'none';
        }
      });
    };

    flickityInstance.on('select', updateDots);
    updateDots();
  }
}
